<template>
    <div class="card-body">
        <div class="form">
            <div class="col-12 mb-4">
                <div class="custom-control custom-switch">
                    <input class="custom-control-input" type="checkbox" v-model="managerLocal.renovar_abono_solo_con_dni" id="renovar_abono_solo_con_dni"/>
                    <label class="custom-control-label text-uppercase" for="renovar_abono_solo_con_dni">Permitir renovaciones online solo con DNI/NIF</label>
                </div>
            </div>
            <div class="col-12 mb-4">
                <div class="custom-control custom-switch">
                    <input class="custom-control-input" type="checkbox" v-model="managerLocal.comprobar_dni" id="comprobar_dni"/>
                    <label class="custom-control-label text-uppercase" for="comprobar_dni">Comprobar DNI para hacer nuevo abono</label>
                </div>
            </div>
            <div class="col-12 mb-4">
                <div class="custom-control custom-switch">
                    <input class="custom-control-input" type="checkbox" v-model="managerLocal.comprobacion_butacas_abonos" id="comprobacion_butacas_abonos"/>
                    <label class="custom-control-label text-uppercase" for="comprobacion_butacas_abonos">Activar comprobación de butacas</label>
                </div>
            </div>
            <div class="col-12 mb-3">
                <label class="form-label" for="informacion">Texto para las condiciones de la compra de abonos mediante plazos:</label>
                <CkEditorComponent v-model="managerLocal.condiciones_abonos_plazos"/>
            </div>
            <hr/>
            <div class="col-12">
                <label for="imagen">Imagen cabecera pdf:</label>
                <p>
                    <small>
                        MEDIDAS: 2182X287 - FORMATO: JPG - PESO MÁXIMO: Menos de 25O KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.imagen_abono_cabecera_url">
                    <img :src="manager.imagen_abono_cabecera_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('imagen_abono_cabecera')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="287"
                        :width="2182"
                        @success="imagenSubida('imagen_abono_cabecera', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <label for="imagen">Imagen publicidad pdf:</label>
                <p>
                    <small>
                        MEDIDAS: 2182X667 - FORMATO: JPG - PESO MÁXIMO: Menos de 25O KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.imagen_abono_publicidad_url">
                    <img :src="manager.imagen_abono_publicidad_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('imagen_abono_publicidad')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="667"
                        :width="2182"
                        @success="imagenSubida('imagen_abono_publicidad', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <label for="imagen">Imagen patrocinadores pdf:</label>
                <p>
                    <small>
                        MEDIDAS: 2182X319 - FORMATO: JPG - PESO MÁXIMO: Menos de 25O KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.imagen_abono_patrocinadores_url">
                    <img :src="manager.imagen_abono_patrocinadores_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('imagen_abono_patrocinadores')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="319"
                        :width="2182"
                        @success="imagenSubida('imagen_abono_patrocinadores', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <Button data-cy="guardar-configuracion" @click="guardarOpciones">Guardar</Button>
            </div>
        </div>
    </div>
</template>

<script>
    import CkEditorComponent from '@/components/common/forms/CkEditorComponent.vue';
    import Dropzone from '@/components/common/Dropzone';

    export default {
        props: ['manager'],
        data() {
            return {
                url: this.config.API_BASE + '/upload/image?permisos=public&api_key=' + localStorage.getItem('token'),
                conf: {},
                managerLocal: this.manager
            }
        },
        methods: {
            guardarOpciones() {
                this.$emit('guardar', this.managerLocal);
            },
            imagenBorrada(campo) {
                switch (campo) {
                    case 'imagen_abono_patrocinadores':
                        this.managerLocal.imagen_abono_patrocinadores = null;
                        this.managerLocal.imagen_abono_patrocinadores_url = null;
                        break;
                    case 'imagen_abono_cabecera':
                        this.managerLocal.imagen_abono_cabecera = null;
                        this.managerLocal.imagen_abono_cabecera_url = null;
                        break;
                    case 'imagen_abono_publicidad':
                        this.managerLocal.imagen_abono_publicidad = null;
                        this.managerLocal.imagen_abono_publicidad_url = null;  
                        break;
                }
            },
            imagenSubida(campo, file, response) {
                switch (campo) {
                    case 'imagen_abono_patrocinadores':
                        this.managerLocal.imagen_abono_patrocinadores = response;
                        break;
                    case 'imagen_abono_cabecera':
                        this.managerLocal.imagen_abono_cabecera = response;
                        break;
                    case 'imagen_abono_publicidad':
                        this.managerLocal.imagen_abono_publicidad = response;
                        break;
                }
            }
        },
        components: {
            Dropzone, CkEditorComponent
        }
    }
</script>
